import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import { Link } from 'react-router-dom';

function handleClick(event) {
  event.preventDefault();
}

export default function IconBreadcrumbs(props) {
  return (
    <div role="presentation" onClick={handleClick}>
      <Breadcrumbs aria-label="breadcrumb">
        <Link
         className='breadLink'
         
          style={{ color:"#616e80"}}
          to={props.link1}
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          {props.previous}
        </Link>
        <Link
          className='breadLink'
          style={{ color:"#616e80"}}
          to={props.link2}
        >
          <WhatshotIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          {props.current}
        </Link>
      </Breadcrumbs>
    </div>
  );
}